import { FormlyFieldConfig } from "@ngx-formly/core";
import { Config } from "src/app/config";


/**
 * Function to avoid entering non valid chars for section label.
 * @param event Keypress event
 */
export function alphaNumericInputValidator(event: any) {
 
  try {   
        //    Ignore input if not valid for integers:            
        //    0 for null values
        //    8 for backspace 
        //    48-57 for 0-9 numbers
        //    45 is minus '-'
        let sectionName = (document.getElementById("sectionLabel") as HTMLInputElement).value;
        if (event.which >= 48 &&  event.which <=57 && sectionName === ""){
          event.preventDefault();
         return false;
        }
        else{
         return true;
        }    
    }
  
   catch (error) {
    // this.logger.warn("keypress event error "+error);
  }

  // Config.previousValue = currentValue;
}
